/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EntitySubtypeResponse
 */
export interface EntitySubtypeResponse {
    /**
     * 
     * @type {string}
     * @memberof EntitySubtypeResponse
     */
    fieldKey: string;
    /**
     * 
     * @type {string}
     * @memberof EntitySubtypeResponse
     */
    value: string;
}

/**
 * Check if a given object implements the EntitySubtypeResponse interface.
 */
export function instanceOfEntitySubtypeResponse(value: object): value is EntitySubtypeResponse {
    if (!('fieldKey' in value) || value['fieldKey'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function EntitySubtypeResponseFromJSON(json: any): EntitySubtypeResponse {
    return EntitySubtypeResponseFromJSONTyped(json, false);
}

export function EntitySubtypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntitySubtypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fieldKey': json['fieldKey'],
        'value': json['value'],
    };
}

export function EntitySubtypeResponseToJSON(json: any): EntitySubtypeResponse {
    return EntitySubtypeResponseToJSONTyped(json, false);
}

export function EntitySubtypeResponseToJSONTyped(value?: EntitySubtypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fieldKey': value['fieldKey'],
        'value': value['value'],
    };
}

